import { DefaultTheme, css } from 'styled-components'
import logo from '../assets/images/logo_black.png'
import logoDark from '../assets/images/logo_white.png'

import zeroExBlack from '../assets/images/0x-brand-black.png'
import zeroExWhite from '../assets/images/0x-brand-white.png'

import { addAlpha } from '../utils/color'

// new colors
export const swaapPurple0 = '#9C96F0'
export const swaapPurple1 = '#4A1DCB'
export const swaapPurple2 = '#01013D'

export const swaapPurple3 = '#BEAFEF'
export const swaapPurple4 = '#AA9AF0'
export const swaapPurple5 = '#9689CF'
export const swaapPurple6 = '#A7A1DA'

export const swaapLightPurple1RGB = '#e3dcf5'
export const swaapLightPurple0 = addAlpha(swaapPurple0, 0.1)
export const swaapMiddlePurple0 = addAlpha(swaapPurple0, 0.3)
export const swaapLightPurple1 = addAlpha(swaapPurple1, 0.1)
export const swaapMiddlePurple1 = addAlpha(swaapPurple1, 0.3)
export const swaapLightPurple2 = addAlpha(swaapPurple2, 0.1)
export const swaapDarkerPurple2 = '#01012b'

// #d8f0e7 = 216, 240, 231
export const white = '#FFF'
export const black = '#000'
export const swaapGold0 = '#FCB32B'
export const swaapLightGold0 = '#FDF0D9'
export const swaapGreen0 = '#1DDD94'
export const swaapMiddleGreen0 = '#8FF0CB'
export const swaapLightGreen0 = '#CDF7E7'
export const swaapLightGreen1 = '#F0F8F5'
export const swaapGreen1 = '#1a9673'

export const swaapRed0 = '#F3729A'
export const swaapRed1 = '#F24242'
export const swaapRed2 = '#EF4676'
export const swaapMiddleRed1 = '#ffedf2'
export const lightGray = '#ededf5'
export const middleGray = '#ebebf5'
export const darkGray = '#666'

export const SwapStyle = {
  smallText: '1.2rem',
  normalText: '1.5rem',
  bigText: '2rem',
  bigTitle: '3.2rem',
  popupWidth: '425px',
}

export const MEDIA_WIDTHS = {
  upToExtraSmall: 500,
  upToSmall: 720,
  upToMedium: 960,
  upToLarge: 1280,
}

const mediaWidthTemplates: {
  [width in keyof typeof MEDIA_WIDTHS]: typeof css
} = Object.keys(MEDIA_WIDTHS).reduce((accumulator, size) => {
  ;(accumulator as any)[size] = (a: any, b: any, c: any) => css`
    @media (max-width: ${(MEDIA_WIDTHS as any)[size]}px) {
      ${css(a, b, c)}
    }
  `
  return accumulator
}, {}) as any

export const lightTheme: DefaultTheme = {
  //    bodySwap: "linear-gradient(#FCB32B, #88FF6D, #1DDD94, #2B99FF, #A63AFF, #F3729A)",
  notMainChainTextColor: swaapPurple1,
  notMainChainBackgroundColor: swaapLightPurple1RGB,
  //    bodySwap: "linear-gradient(336deg, rgba(255,255, 255,.8), rgba(255,255, 255,0) 90%), linear-gradient(127deg, rgba(255, 255, 255,.8), rgba(255,255, 255, 0.8) 90%), linear-gradient(217deg, rgba(29,221,148,.8), rgba(29,221,148,0) 90%)",
  //    bodySwap: "linear-gradient(rgb(216, 240, 231), #FFF 30vh), linear-gradient(336deg, #FFF, #FFF 80%), linear-gradient(127deg, #FFF, #FFF 80%)",
  //    bodySwap: "rgb(216, 240, 231)",
  bodySwap: `radial-gradient(50% 50% at 50% 25%, ${swaapLightPurple1} 0%, #FFF 100%)`,
  bodyFaucet: `radial-gradient(50% 50% at 50% 25%, ${swaapLightPurple1} 0%, #FFF 100%)`,
  //    bodySwap: white,
  body: `radial-gradient(50% 50% at 50% 25%, ${swaapLightPurple1} 0%, #FFF 100%)`,
  text: swaapPurple2,
  shadowText: swaapPurple2,
  link: swaapPurple1,
  balanceExceeded: swaapRed0,
  logo: logo,
  iconColor: swaapLightPurple1,
  brandTextColor: swaapPurple1,
  brandTextColorHover: swaapPurple1,
  productTextColor: swaapPurple2,
  productBorderColor: swaapPurple2,
  productFeatureTextColor: swaapPurple2,
  productReleaseTextColor: swaapPurple2,
  headerBackground: 'inherited',
  footerBackgroundColor: white,
  footerTextColor: swaapPurple2,
  footerBorderColor: white,
  footerLinkTextColor: swaapPurple2,
  footerBrandTextColorHover: swaapPurple1,
  productAppButtonTextColor: white,
  productAppButtonBorderColor: white,
  tradePanelBackgroundColor: white,
  tradePanelTextColor: swaapPurple2,
  tradePanelInputTextColor: swaapPurple2,
  tradePanelBorderColor: swaapLightPurple1,
  tradePanelShadow:
    '0 0px 0px 0 rgb(200 200 200 / 30%), 10px 10px 50px 10px rgb(200 200 200 / 15%)',
  tradeInputPanelBackgroundColor: white,
  tradeInputPanelTextColor: swaapPurple2,
  tradeInputPanelBorderColor: white,
  tradeInputPanelBorderColorHover: swaapLightPurple1,
  validationButtonBackgroundColor: swaapPurple2,
  validationButtonTextColor: white,
  validationButtonBackgroundNotReadyColor: lightGray,
  validationButtonTextNotReadyColor: swaapPurple2,
  validationButtonColorHover: white,
  validationButtonBackgroundColorHover: swaapPurple1,
  validationButtonShadow:
    '0px 1px 1px 0px rgb(200 200 200 / 30%), 0 3px 8px 3px rgb(200 200 200 / 15%)',
  tradeCurrencyTextColor: swaapPurple2,
  tradeCurrencyBackgroundColor: white,
  tradeEmptyCurrencyTextColor: white,
  tradeEmptyCurrencyBackgroundColor: swaapPurple2,
  tradeCurrencyShadow:
    '0 3px 20px 0 rgb(200 200 200 / 30%), 0 0px 1px 0px rgb(200 200 200 / 15%)',
  modeButtonTextColorActivated: white,
  modeButtonTextColorUnactivated: swaapPurple2,
  modeButtonBorderColor: swaapLightPurple1,
  modeButtonBackgroundColorActivated: swaapPurple2,
  modeButtonBackgroundColorUnactivated: white,
  modeButtonsShadow:
    '0 0px 0px 0 rgb(200 200 200 / 30%), 0 0px 0px 0px rgb(200 200 200 / 15%)',
  swapCurrencySelectorPanelTextColor: swaapPurple2,
  swapCurrencySelectorPanelBackgroundColor: white,
  tradeCurrencySelectorBackgroundColorHover: swaapLightPurple1,
  poolRowBackgroundColor: white,
  poolRowBackgroundColorHover: white,
  poolCompositionWeightTextColor: swaapPurple2,
  poolCompositionSymbolTextColor: swaapPurple2,
  poolCompositionBackgroundColor: white,
  poolCompositionBorderColor: white,
  poolRowShadow:
    '0 1px 1px 0 rgb(200 200 200 / 30%), 0 1px 16px 5px rgb(200 200 200 / 15%)',
  poolPanelShadow:
    '0 0px -1px 0 rgb(200 200 200 / 30%), 0 0px 10px 0px rgb(200 200 200 / 15%)',
  poolPanelBackgroundColor: 'rgba(255, 255, 255, 0.75)',
  poolPanelTextColor: swaapPurple2,
  poolPanelBorderColor: 'inherited',
  poolPanelBowShadowMobile:
    '0px 0px 0px 0px rgb(200 200 200 / 30%), 0 3px 20px 3px rgb(200 200 200 / 15%)',
  poolValueTextColor: swaapPurple2,
  poolLoadingRowTextColor: swaapPurple2,
  poolPanelButtonTextColor: white,
  poolPanelButtonColorHover: white,
  poolPanelButtonBackgroundColor: swaapPurple2,
  poolPanelButtonBackgroundColorHover: swaapPurple1,
  poolPanelButtonBorderColor: swaapPurple2,
  poolPanelButtonBorderColorHover: swaapPurple1,
  poolPanelButtonShadow:
    '0px 1px 1px 0px rgb(200 200 200 / 30%), 0 3px 8px 3px rgb(200 200 200 / 15%)',
  poolJoinPanelButtonShadow:
    '0px 5px 5px 0px rgb(200 200 200 / 30%), 0 8px 16px 8px rgb(200 200 200 / 15%)',
  poolNewButtonTextColor: white,
  poolNewButtonBackgroundColor: swaapPurple1,
  poolNewButtonShadow:
    '0px 2px 2px 0px rgb(200 200 200 / 30%), 0 2px 16px 2px rgb(200 200 200 / 15%)',
  poolNewPanelShadow:
    '0px 1px 1px 0px rgb(200 200 200 / 30%), 0 3px 8px 3px rgb(200 200 200 / 15%)',
  poolNewPanelColor: 'rgb(255, 255, 255, 0.9)',
  tradeCurrencyWeightTextColor: swaapPurple2,
  poolNewCurrencyBackgroundColor: white,
  poolNewCurrencyShadow:
    '0px 2px 2px 0px rgb(200 200 200 / 30%), 0 2px 15px 2px rgb(200 200 200 / 15%)',
  addNewAssetInputBackgroundColor: '#f5f7f6',
  walletBackgroundColor: swaapLightPurple0,
  walletBackgroundColorPending: swaapPurple2,
  walletBorderColor: white,
  walletBorderColorHover: swaapLightPurple0,
  walletTextColor: swaapPurple2,
  walletTextColorPending: white,
  poolsBackgroundColor: 'inherited',
  myInvestBackgroundColor: 'inherited',
  learnTextColor: swaapPurple2,
  learnBackgroundColor: white,
  learnBorderColor: `linear-gradient(333deg, ${swaapLightPurple0}, ${swaapLightPurple1}, ${swaapLightPurple0})`,
  learnShadow:
    '0px 0px 0px 0px rgb(200 200 200/ 30%), 0 1px 20px 1px rgb(200 200 200/ 15%)',
  walletShadow: `none`,
  myPoolSummaryBorderColor: '#C3CCC7',
  dropdownSelectedColor: swaapPurple2,
  dropdownNotSelectedColor: white,
  poolNewAssetPanelBorderColor: '#F8F8F8',
  poolNewAssetPanelBorderColorHover: '#DDD',
  poolNewAddPanelPlaceholderTextColor: '#CCC',
  poolNewAssetRowValidateButtonShadow: 'none',
  poolNewAssetRowValidateButtonTextColor: swaapPurple2,
  poolNewAssetRowValidateButtonBackgroundColor: '#EEE',
  poolNewAssetRowValidateButtonBorderColor: '#EEE',
  poolNewAssetRowValidateButtonBorderColorHover: swaapPurple2,
  swapCurrencySelectorPanelWrapperBackgroundColor: 'rgb(155, 155, 155, 0.3)',
  //	walletSelectionShadow: "0px 1px 1px 0px rgb(200 200 200 / 30%), 0 1px 1px 1px rgb(200 200 200 / 15%)",
  walletSelectionShadow: 'none',
  walletSelectionTextColor: swaapPurple2,
  walletSelectionBackgroundColor: white,
  walletSelectionBackgroundColorHover: '#EEE',
  walletModalTitleTextColor: '#AAA',
  txTransactionStateColor: swaapPurple2,
  poolJoinPanelButtonBackgroundColor: swaapPurple1,
  poolNewPanelInputTextColor: swaapPurple2,
  poolJoinPanelInputTextColor: swaapPurple2,
  maxButtonColor: swaapPurple1,
  maxButtonBackgroundColor: white,
  maxButtonBorderColor: swaapPurple1,
  arrowBorderColor: swaapPurple2,
  arrowShadowColorActive: swaapPurple0,
  arrowBorderColorActive: swaapPurple0,
  arrowDownAbsoluteContainerBorderColor: swaapLightPurple1,
  arrowDownAbsoluteContainerBackgroundColor: white,
  subNavigatorTextColorSelected: white,
  subNavigatorBackgroundColorSelected: swaapPurple2,
  subNavigatorBorderColorSelected: swaapPurple2,
  subNavigatorBackgroundColor: swaapLightPurple1,
  multiAllowanceBackgroundColor: swaapLightPurple0,
  innerMediumShadow:
    'inset 0px 1px 1px 0px rgb(200 200 200 / 30%), inset 0 2px 2px 2px rgb(200 200 200 / 15%);',
  modalBackground: white,
  modalBorder: swaapRed0,
  modalBoxBackground: white,
  modalBoxBorder: swaapPurple4,
  modalButtonBackground: swaapLightPurple1,
  modalButtonBorder: swaapLightPurple0,
  modalButtonColor: swaapPurple2,
  modalButtonBackgroundColor: swaapLightPurple0,
  modalButtonBorderColor: swaapPurple1,
  modalButtonBackgroundColorHover: swaapLightPurple0,
  modalButtonColorHover: white,
  addToButtonColor: swaapPurple2,
  addToButtonBackgroundColor: swaapLightPurple0,
  walletPendingTxsTextColor: swaapPurple2,
  walletPendingTxsBackgroundColor: swaapLightPurple2,
  tokenEquivalenceSectionBackgroundColor: swaapLightPurple0,
  appStatusColorOutdated: swaapPurple2,
  appStatusBackgroundColorOutdated: swaapLightPurple0,
  appStatusBorderColorOutdated: swaapLightPurple0,
  appStatusColorUpToDate: swaapPurple2,
  bridgeColor: white,
  bridgeBackgroundColor: swaapPurple1,
  bridgeBorderColor: swaapPurple1,
  bridgeBorderColorHover: swaapPurple0,
  rewardsBorderColor: swaapLightPurple0,
  rewardsBackgroundColor: swaapLightPurple1,
  rewardsColor: swaapPurple2,
  tooltipContainerBackgroundColor: white,
  tooltipContainerBorderColor: swaapLightPurple0,
  tooltipContainerColor: swaapPurple2,
  viaAggregatorColor: swaapPurple2,
  viaAggregatorBackgroundColor: white,
  viaAggregatorInputColor: swaapPurple2,
  viaAggregatorInputBackgroundColor: swaapLightPurple0,
  viaAggregatorSectionColor: swaapPurple2,
  viaAggregatorSectionBackgroundColor: swaapLightPurple0,
  aggregatorLogo: zeroExBlack,
  aggregatorLogoSize: 40,
  // media queries
  mediaWidth: mediaWidthTemplates,
  analyticsButtonColor: swaapPurple1,
  analyticsButtonSeparatorColor: swaapLightPurple1RGB,
}

export const darkTheme: DefaultTheme = {
  ...lightTheme,
  notMainChainTextColor: swaapPurple1,
  notMainChainBackgroundColor: swaapLightPurple1RGB,
  bodySwap: `radial-gradient(50% 50% at 50% 25%, ${swaapDarkerPurple2} 0%, ${swaapPurple2} 100%)`,
  bodyFaucet: `radial-gradient(50% 50% at 50% 25%, ${swaapDarkerPurple2} 0%, ${swaapPurple2} 100%)`,
  body: `radial-gradient(50% 50% at 50% 25%, ${swaapDarkerPurple2} 0%, ${swaapPurple2} 100%)`,
  text: white,
  link: swaapPurple6,
  balanceExceeded: swaapRed0,
  logo: logoDark,
  shadowText: lightGray,
  iconColor: swaapLightPurple0,
  brandTextColor: white,
  brandTextColorHover: white,
  productBorderColor: white,
  productReleaseTextColor: white,
  footerBackgroundColor: '#020E09',
  footerTextColor: white,
  footerBorderColor: '#020E09',
  footerLinkTextColor: 'FFF',
  productAppButtonBorderColor: swaapPurple2,
  tradePanelBackgroundColor: swaapPurple2,
  tradePanelTextColor: white,
  tradePanelInputTextColor: white,
  tradePanelBorderColor: swaapDarkerPurple2,
  tradePanelShadow:
    '0 0px 0px 0 rgb(16 16 16 / 30%), 10px 10px 50px 10px rgb(16 16 16 / 15%)',
  tradeInputPanelBackgroundColor: swaapPurple2,
  tradeInputPanelTextColor: white,
  tradeInputPanelBorderColor: swaapLightPurple2,
  tradeInputPanelBorderColorHover: swaapLightPurple0,
  validationButtonBackgroundColor: white,
  validationButtonTextColor: swaapPurple2,
  validationButtonBackgroundNotReadyColor: middleGray,
  validationButtonTextNotReadyColor: swaapPurple2,
  validationButtonColorHover: swaapPurple2,
  validationButtonBackgroundColorHover: swaapPurple4,
  validationButtonShadow:
    '0px 1px 1px 0px rgb(16 16 16 / 15%), 0 3px 8px 3px rgb(16 16 16 / 15%)',
  tradeCurrencyTextColor: white,
  tradeCurrencyBackgroundColor: swaapPurple2,
  tradeEmptyCurrencyTextColor: white,
  tradeEmptyCurrencyBackgroundColor: swaapPurple1,
  tradeCurrencyShadow:
    '0 3px 20px 0 rgb(16 16 16 / 30%), 0 0px 1px 0px rgb(16 16 16 / 15%)',
  modeButtonTextColorActivated: swaapPurple2,
  modeButtonTextColorUnactivated: white,
  modeButtonBorderColor: swaapDarkerPurple2,
  modeButtonBackgroundColorActivated: white,
  modeButtonBackgroundColorUnactivated: swaapPurple2,
  modeButtonsShadow:
    '0 0px 0px 0 rgb(16 16 16/ 30%), 0 0px 0px 0px rgb(16 16 16/ 15%)',
  swapCurrencySelectorPanelTextColor: white,
  swapCurrencySelectorPanelBackgroundColor: swaapPurple2,
  tradeCurrencySelectorBackgroundColorHover: swaapDarkerPurple2,
  poolRowBackgroundColor: swaapPurple2,
  poolRowBackgroundColorHover: swaapPurple2,
  poolCompositionWeightTextColor: white,
  poolCompositionSymbolTextColor: white,
  poolCompositionBackgroundColor: swaapPurple2,
  poolCompositionBorderColor: swaapPurple2,
  poolRowShadow:
    '0 1px 3px 0 rgb(16 16 16/ 30%), 0 3px 8px 3px rgb(16 16 16/ 15%)',
  poolPanelShadow:
    '0 0px -1px 0 rgb(16 16 16/ 30%), 0 0px 10px 0px rgb(16 16 16/ 15%)',
  poolPanelBackgroundColor: 'rgba(1, 1, 61, 0.75)',
  poolPanelTextColor: white,
  poolPanelBorderColor: 'inherited',
  poolPanelBowShadowMobile:
    '0px 0px 0px 0px rgb(16 16 16 / 30%), 0 3px 20px 3px rgb(16 16 16 / 15%)',
  poolValueTextColor: white,
  poolLoadingRowTextColor: white,
  poolPanelButtonTextColor: swaapPurple2,
  poolPanelButtonColorHover: swaapPurple2,
  poolPanelButtonBackgroundColor: white,
  poolPanelButtonBackgroundColorHover: swaapPurple0,
  poolPanelButtonBorderColor: swaapPurple2,
  poolPanelButtonBorderColorHover: swaapPurple0,
  poolPanelButtonShadow:
    '0px 1px 1px 0px rgb(16 16 16/ 30%), 0 3px 8px 3px rgb(16 16 16/ 15%)',
  poolJoinPanelButtonShadow:
    '0px 2px 2px 0px rgb(16 16 16/ 30%), 0 5px 12px 5px rgb(16 16 16/ 15%)',
  poolNewButtonShadow:
    '0px 1px 1px 0px rgb(16 16 16/ 30%), 0 3px 8px 3px rgb(16 16 16/ 15%)',
  poolNewPanelShadow:
    '0px 3px 3px 0px rgb(16 16 16/ 30%), 0 5px 16px 5px rgb(16 16 16/ 15%)',
  poolNewPanelColor: 'rgb(46, 46, 46, 0.9)',
  tradeCurrencyWeightTextColor: '#CCC',
  poolNewCurrencyBackgroundColor: swaapPurple1,
  poolNewCurrencyShadow:
    '0px 2px 2px 0px rgb(16 16 16/ 30%), 0 2px 15px 2px rgb(16 16 16/ 15%)',
  addNewAssetInputBackgroundColor: '#353837',
  walletBackgroundColor: swaapDarkerPurple2,
  walletBackgroundColorPending: swaapPurple1,
  walletBorderColor: swaapDarkerPurple2,
  walletBorderColorHover: swaapLightPurple0,
  walletTextColor: white,
  walletTextColorPending: white,
  learnTextColor: white,
  learnBackgroundColor: swaapPurple2,
  learnBorderColor: `linear-gradient(333deg, ${swaapMiddlePurple1}, ${swaapMiddlePurple1}, ${swaapMiddlePurple1})`,
  learnShadow:
    '0px 0px 0px 0px rgb(16 16 16/ 30%), 0 1px 20px 1px rgb(16 16 16/ 15%)',
  walletShadow: 'none',
  myPoolSummaryBorderColor: swaapPurple1,
  dropdownSelectedColor: white,
  dropdownNotSelectedColor: swaapPurple2,
  poolNewAssetPanelBorderColor: '#333',
  poolNewAssetPanelBorderColorHover: '#222',
  poolNewAssetRowValidateButtonTextColor: '#CCC',
  poolNewAssetRowValidateButtonBackgroundColor: '#222',
  poolNewAssetRowValidateButtonBorderColor: '#222',
  poolNewAssetRowValidateButtonBorderColorHover: '#CCC',
  walletSelectionTextColor: white,
  walletSelectionBackgroundColor: swaapPurple1,
  walletSelectionBackgroundColorHover: '#333',
  walletModalTitleTextColor: '#666',
  txTransactionStateColor: '#666',
  maxButtonColor: white,
  maxButtonBackgroundColor: swaapPurple2,
  maxButtonBorderColor: white,
  arrowBorderColor: white,
  arrowShadowColorActive: swaapPurple0,
  arrowBorderColorActive: swaapPurple0,
  arrowDownAbsoluteContainerBorderColor: swaapDarkerPurple2,
  arrowDownAbsoluteContainerBackgroundColor: swaapPurple0,
  subNavigatorTextColorSelected: white,
  subNavigatorBackgroundColorSelected: swaapPurple2,
  subNavigatorBorderColorSelected: swaapPurple0,
  subNavigatorBackgroundColor: swaapPurple0,
  multiAllowanceBackgroundColor: swaapDarkerPurple2,
  innerMediumShadow:
    'inset 0px 3px 3px 0px rgb(16 16 16 / 30%), inset 0 6px 6px 6px rgb(16 16 16 / 15%);',
  modalBackground: swaapPurple2,
  modalBorder: swaapRed0,
  modalBoxBackground: swaapLightPurple0,
  modalBoxBorder: swaapPurple0,
  modalButtonBackground: swaapLightPurple1,
  modalButtonBorder: swaapPurple1,
  modalButtonColor: white,
  modalButtonBackgroundColor: swaapDarkerPurple2,
  modalButtonBorderColor: swaapLightPurple0,
  modalButtonBackgroundColorHover: swaapDarkerPurple2,
  modalButtonColorHover: swaapPurple0,
  addToButtonColor: white,
  addToButtonBackgroundColor: swaapLightPurple2,
  walletPendingTxsTextColor: white,
  walletPendingTxsBackgroundColor: swaapDarkerPurple2,
  tokenEquivalenceSectionBackgroundColor: swaapDarkerPurple2,
  appStatusColorOutdated: white,
  appStatusBackgroundColorOutdated: swaapDarkerPurple2,
  appStatusBorderColorOutdated: swaapPurple2,
  appStatusColorUpToDate: white,
  bridgeColor: swaapPurple2,
  bridgeBackgroundColor: swaapPurple0,
  bridgeBorderColor: swaapLightPurple0,
  bridgeBorderColorHover: swaapPurple0,
  rewardsColor: white,
  rewardsBorderColor: swaapDarkerPurple2,
  rewardsBackgroundColor: swaapDarkerPurple2,
  tooltipContainerBackgroundColor: swaapPurple2,
  tooltipContainerBorderColor: swaapDarkerPurple2,
  tooltipContainerColor: white,
  viaAggregatorColor: white,
  viaAggregatorBackgroundColor: swaapDarkerPurple2,
  viaAggregatorInputColor: white,
  viaAggregatorInputBackgroundColor: swaapDarkerPurple2,
  viaAggregatorSectionColor: white,
  viaAggregatorSectionBackgroundColor: swaapDarkerPurple2,
  aggregatorLogo: zeroExWhite,
  aggregatorLogoSize: 40,
  analyticsButtonColor: swaapPurple0,
  analyticsButtonSeparatorColor: swaapDarkerPurple2,
}
